import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { animateScroll as scroll } from "react-scroll";
import "./HowItWorks.css";
import TimeLineHowWorks from "./TimeLineHowWorks/TimeLineHowWorks";
import MobileTimeLine from "./MobileTimeLine/MobileTimeLine";

export default function HowItWorks() {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === '/howitworks') {
      scroll.scrollTo('how-it-works', {
        smooth: true,
        offset: -100,
        duration: 100,
      });
    }
  }, [location]);
  return (
    <>
      <section className="container PrivacyPolicySec py-5 mb-5 d-md-block d-none">
        <div className="row">
          <h1 className="py-1 text-center fw-bold">How it works</h1>
        </div>
      </section>
      <section id="how-it-works" className="howBG pb-5 mb-5">
        <div className="desktop-view">
          <TimeLineHowWorks />
        </div>
        <MobileTimeLine/>
      </section>
    </>
  );
}
